import * as React from "react" 
import Tag from "./Tag"
import { useStaticQuery, graphql } from "gatsby"

export default function Categories() {

  const data = useStaticQuery(graphql`
    query {
      allWpCategory(filter: {count: {gt: 0}}, sort: {order: ASC, fields: name}) {
        nodes {
          id
          name
          link
        }
      }
    }  
  `)

  return (
    <div className="mt-4r">
      <p className="fw-700 mb-2r">Categorias do Blog</p>
      <div className="d-flex flex-wrap">
        {
          data.allWpCategory.nodes.map(node => (
            <Tag to={node.link} text={node.name} btnClass="dt" key={node.id} />
          ))
        }
      </div>
    </div>
  )
}